module.exports = __webpack_public_path__ + "static/media/Copy of  eSports Ninja - APPROVED.0f5ecbb5.svg";